import { Route, Switch, useLocation } from "wouter";
import { useT } from "./lib/i18n";
import { Layout } from "./components/Layout";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { MapPage } from "./pages/MapPage";
import { FeedPage } from "./pages/FeedPage";
import { DiscoverPage } from "./pages/DiscoverPage";
import { NewOutingPage } from "./pages/NewOutingPage";
import { ProfilePage } from "./pages/ProfilePage";
import { TicklistPage } from "./pages/TicklistPage";
import { SavedPage } from "./pages/SavedPage";
import { CalendarPage } from "./pages/CalendarPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { VerifyEmailPage } from "./pages/VerifyEmailPage";
import { PlacePage } from "./pages/PlacePage";
import { NewPlacePage } from "./pages/NewPlacePage";
import { RoutePage } from "./pages/RoutePage";
import { RegionPage } from "./pages/RegionPage";
import { OutingPage } from "./pages/OutingPage";
import { EditOutingPage } from "./pages/EditOutingPage";
import { PersonPage } from "./pages/PersonPage";
import { GroupPage } from "./pages/GroupPage";
import { NewGroupPage } from "./pages/NewGroupPage";
import { EditGroupPage } from "./pages/EditGroupPage";
import { EventPage } from "./pages/EventPage";
import { NewEventPage } from "./pages/NewEventPage";
import { EditEventPage } from "./pages/EditEventPage";
import { AdminReportsPage } from "./pages/AdminReportsPage";

export function App() {
  const [location] = useLocation();
  const { t } = useT();

  return (
    <ErrorBoundary>
      <Layout>
        {/* Inner boundary keeps the shell alive when a page crashes; keyed by
            location so navigating away clears the error state. */}
        <ErrorBoundary key={location}>
          <Switch>
            <Route path="/" component={MapPage} />
            <Route path="/feed" component={FeedPage} />
            <Route path="/discover" component={DiscoverPage} />
            <Route path="/new" component={NewOutingPage} />
            <Route path="/ticklist" component={TicklistPage} />
            <Route path="/saved" component={SavedPage} />
            <Route path="/calendar" component={CalendarPage} />
            <Route path="/profile" component={ProfilePage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/register" component={RegisterPage} />
            <Route path="/forgot" component={ForgotPasswordPage} />
            <Route path="/reset" component={ResetPasswordPage} />
            <Route path="/verify" component={VerifyEmailPage} />
            <Route path="/admin/reports" component={AdminReportsPage} />
            {/* Must precede /place/:id or "new" is taken as a place id. */}
            <Route path="/place/new" component={NewPlacePage} />
            <Route path="/place/:id">{(params) => <PlacePage id={params.id} />}</Route>
            <Route path="/route/:id">{(params) => <RoutePage id={params.id} />}</Route>
            <Route path="/region/:id">{(params) => <RegionPage id={params.id} />}</Route>
            <Route path="/outing/:id/edit">{(params) => <EditOutingPage id={params.id} />}</Route>
            <Route path="/outing/:id">{(params) => <OutingPage id={params.id} />}</Route>
            <Route path="/person/:id">{(params) => <PersonPage id={params.id} />}</Route>
            {/* Must precede /group/:id or "new" is taken as a group id. */}
            <Route path="/group/new" component={NewGroupPage} />
            <Route path="/group/:id/edit">{(params) => <EditGroupPage id={params.id} />}</Route>
            <Route path="/group/:id">{(params) => <GroupPage id={params.id} />}</Route>
            {/* Must precede /event/:id or "new" is taken as an event id. */}
            <Route path="/event/new" component={NewEventPage} />
            <Route path="/event/:id/edit">{(params) => <EditEventPage id={params.id} />}</Route>
            <Route path="/event/:id">{(params) => <EventPage id={params.id} />}</Route>
            <Route>
              <div className="p-10 text-center text-sm text-muted-foreground">{t("nav.notFound")}</div>
            </Route>
          </Switch>
        </ErrorBoundary>
      </Layout>
    </ErrorBoundary>
  );
}
